import React from 'react'
import { Link } from 'react-router-dom'
import Seo from '../components/Seo'

export default function ForbiddenPage() {
  return (
    <>
      <Seo
        title="403 - Adgang nægtet :: Lyn Entreprenør"
        description="Du har ikke adgang til denne side eller ressource."
      />

      <section className="py-24 sm:py-32 bg-slate-50 relative overflow-hidden flex items-center justify-center min-h-[60vh]">
        <div className="max-w-xl mx-auto px-4 text-center space-y-6">
          <div className="inline-flex h-20 w-20 items-center justify-center rounded-2xl bg-amber-100 text-amber-600 text-3xl shadow-sm">
            <i className="fa-solid fa-lock" aria-hidden="true" />
          </div>

          <h1 className="text-4xl sm:text-5xl font-black text-slate-900 tracking-tight">
            403 - Adgang nægtet
          </h1>

          <p className="text-base text-slate-600 leading-relaxed">
            Du har ikke tilladelse til at tilgå denne side eller ressource på Lyn Entreprenør ApS' hjemmeside.
          </p>

          <div className="pt-4 flex flex-wrap items-center justify-center gap-3">
            <Link
              to="/"
              className="inline-flex items-center gap-2 rounded-xl bg-red-600 px-6 py-3.5 text-sm font-bold text-white hover:bg-red-700 transition"
            >
              <i className="fa-solid fa-house" aria-hidden="true" />
              <span>Tilbage til forsiden</span>
            </Link>

            <Link
              to="/kontakt"
              className="inline-flex items-center gap-2 rounded-xl bg-white border border-slate-300 px-6 py-3.5 text-sm font-bold text-slate-700 hover:bg-slate-100 transition"
            >
              <span>Kontakt os</span>
            </Link>
          </div>
        </div>
      </section>
    </>
  )
}
